<button [attr.type]="type()" [class]="btnClass()" [disabled]="disabled()">
  @if (icon()) {
  <i class="{{ icon() }}"></i>
  }
  <span class="label"><ng-content></ng-content></span>
</button>
